import {
    RECOMMENDATION_FAILED,
    RECOMMENDATION_RESULTS
} from '../../actions/actionTypes';

export const initialState = {
    campgroundId: '',
    errorMsg: '',
    failed: false,
    features: {},
    model: '',
    ready: false,
    referrer: '',
    results: []
};

// Store the persistent state props
const setStorage = (state) => {
    return state;
};


/**
 *
 * @param {Object} state - The current state associated with this reducer
 * @param {Object} params - The action params, including the type.
 */
export default function recommendations(state = initialState, action) {
    let st = state;
    switch (action.type) {
        case RECOMMENDATION_FAILED:
            st = {
                ...state,
                failed: true,
                errorMsg: action.errorMsg,
                results: []
            };
            return setStorage(st);
        case RECOMMENDATION_RESULTS:
            st = {
                ...state,
                failed: false,
                errorMsg: '',
                results: action.results
            };
            return setStorage(st);
        default:
            return state;
    }
}

